// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import '../../../styles/meta.css';
import '../../../styles/fields.css';

export default class FieldsMeta extends React.Component {

    render = () => {
        return (<div className="meta-container">
        
            {/* <div
                className="meta-thumbnail-stack"
                style={{
                    backgroundImage: "url('https://static.stax.ai/images/icons/" + (this.props.user && this.props.user.enableDarkMode ? "dark/" : "") + "folder-big-field.png')"
                }}
            >{this.props.fields ? this.props.fields.length : 0} distinct fields</div> */}

            <div className="meta-details meta-details-nothumb">
                <div className="meta-details-name">Fields and Filters</div>

                <div className="archives-hint">
                    Stax·ai is all about making your data more accessible and actionable. We just introduced <strong>Fields</strong> - a new way to attach tags or metadata to your documents.<br /><br />
                    Creating fields allows you to filter through and sort your documents in more ways than just by stack.<br /><br />
                </div>

                <div className="meta-details-name">Automatic field extraction</div>
                <div className="archives-hint">
                    Want your bots to extract fields and metadata for you? Awesome! Stax·ai bots automatically extracts the standard fields: <strong>PID</strong> (Personal Identifier) and <strong>PName</strong> (Person Name)<br /><br />
                    You can also go into each stack and add a list of <strong>field keys</strong> to look for. For example: DATE OF BIRTH, SSN, etc.
                </div>
            </div>

        </div>);
    }

};